"use client";

import Link from "next/link";
import Image from "next/image";
import { CustomerSelector } from "@/components/CustomerSelector";
import { UserInfo } from "@/components/UserInfo";
import { NavLinks } from "./NavLinks";
import { UnifiedSearch, SearchButton } from "./UnifiedSearch";
import { useState } from "react";
import { useSession } from "@/lib/auth-client";

export default function Navbar() {
    const [searchOpen, setSearchOpen] = useState(false);
    const { data: session } = useSession();
    return (
        <div className="sticky top-0 w-full h-16 z-10 px-3 flex justify-between items-center force-dark bg-background text-foreground">
            <Link href="/dashboard" className="hidden sm:block pr-2 shrink-0">
                <Image className="" src={'/kuorilogo.svg'} alt="Main page" width={80} height={24} />
            </Link>

            <div className="w-full flex justify-end xl:justify-center items-center">
                <NavLinks session={session} />
                <div className="relative ml-2 shrink-0">
                    <UnifiedSearch
                        session={session}
                        open={searchOpen}
                        onOpenChange={setSearchOpen}
                    />
                </div>
            </div>

            <div className="flex items-center gap-0.5 sm:gap-1 md:gap-2 lg:gap-4 shrink-0 ml-1 sm:ml-2">
                <SearchButton onClick={() => setSearchOpen(!searchOpen)} session={session} />
                <CustomerSelector session={session} />
                <UserInfo session={session} />
            </div>
        </div>
    );
}
